import moment from 'moment'

import Router from '../router'

const propertyMappingTable = {
  reactions: 'r',
  audienceId: 'd',
  audienceName: 'e',
  audienceTeam: 'm',
  audienceEmail: 'l',
  audienceEmoji: 'i',
  resetTimeStamp: 'p',
  answeredSlideIds: 's',
  alreadyClearedDataSlides: 'a',
  visited: 'v',
}

const clearValueByPresentation = (presentationId) => {
  try {
    const key = `aha-presentation-${presentationId}`

    localStorage.setItem(key, '{}')
  } catch {
    Router.app.$router.push({ query: {} })
  }
}

const getValueByPresentation = (presentationId, property, defaultValue) => {
  const mappedProperty = propertyMappingTable[property] || property

  try {
    const key = `aha-presentation-${presentationId}`
    const jsonData = localStorage.getItem(key) || '{}'
    const data = JSON.parse(jsonData)
    // clear local storage after 3 days
    if (moment().diff(moment.unix(data.updatedAt), 'days') >= 3) {
      clearValueByPresentation(presentationId)
    } else if (data[mappedProperty]) {
      return data[mappedProperty]
    }
  } catch {
    const value = Router.app.$route.query[mappedProperty]

    if (value) return JSON.parse(value)
  }

  if (defaultValue !== undefined) return defaultValue

  return null
}

const setValueByPresentation = (presentationId, property, value) => {
  const mappedProperty = propertyMappingTable[property] || property

  try {
    const key = `aha-presentation-${presentationId}`
    const jsonData = localStorage.getItem(key) || '{}'
    const data = JSON.parse(jsonData)

    data[mappedProperty] = value
    data.updatedAt = moment().unix()

    localStorage.setItem(key, JSON.stringify(data))
  } catch {
    const query = { ...Router.app.$route.query }

    query[mappedProperty] = JSON.stringify(value)
    Router.app.$router.push({ query })
  }
}

const updateValueByPresentation = (presentationId, property, value) => {
  const oldValue = getValueByPresentation(presentationId, property)

  if (oldValue !== value) {
    setValueByPresentation(presentationId, property, value)
  }
}

export default {
  setValueByPresentation,
  getValueByPresentation,
  clearValueByPresentation,
  updateValueByPresentation,
}
